import { jwtDecode } from 'jwt-decode';

import { useAdminJwt } from './useAdminJwt';

type JwtClaims = {
  // standard items
  sub: string;
  exp: number;
  iat: number;

  // user id
  id: number;

  // user account type/role
  role?: string;
};

export const useRole = () => {
  const { token } = useAdminJwt();

  if (!token) {
    return { role: null };
  }

  try {
    const claims = jwtDecode<JwtClaims>(token);
    return { role: claims.role };
  } catch {
    return { role: null };
  }
};
